import { AxiosResponse } from "axios";
import { ForgotPasswordFormValues, LogInFormValues, ResetPasswordFormValues, SignupFormValues } from "./authInterface";
import { CustomAxiosRequestConfig, userServiceAPI } from "../../http/http";

export const login = (formValues: LogInFormValues): Promise<AxiosResponse<any>> =>
	userServiceAPI.post('/auth/signin', formValues, {
		applyAuth: false,
	} as CustomAxiosRequestConfig);

export const forgotPassword = (formValues: ForgotPasswordFormValues): Promise<AxiosResponse<any>> =>
	userServiceAPI.post('/auth/forgot-password', formValues, {
		applyAuth: false,
	} as CustomAxiosRequestConfig);

export const resetPassword = (formValues: ResetPasswordFormValues): Promise<AxiosResponse<any>> =>
	userServiceAPI.patch(`/auth/reset-password/${formValues.token}`, formValues, {
		applyAuth: false,
	} as CustomAxiosRequestConfig);

export const signup = (formValues: SignupFormValues): Promise<AxiosResponse<any>> =>
	userServiceAPI.post(`/auth/user/signup`, formValues, {
		applyAuth: false,
	} as CustomAxiosRequestConfig);